// removed by extract-text-webpack-plugin
module.exports = {"header":"CardContainer__header___3HPXv","heading":"CardContainer__heading___QwOiP","tabs":"CardContainer__tabs___2oj2G","tabButton":"CardContainer__tabButton___ZPvGS","statement":"CardContainer__statement___2Uoy1","makeAPayment":"CardContainer__makeAPayment___3aRAB","cardSettings":"CardContainer__cardSettings___3GmZA","settingsLabel":"CardContainer__settingsLabel___2XbyQ","purchaseCard":"CardContainer__purchaseCard___10xzu"};


//////////////////
// WEBPACK FOOTER
// ./src/card/CardContainer.scss
// module id = 1219
// module chunks = 0